/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.37.0
 * @since 1.37.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { WIZARD_STORAGE_CLEAR_STEPS } from '@modules/wizard/wizardConstants';

import { TWizardChangeRoleActions } from './types/wizardChangeRoleActionTypes';
import { IWizardChangeRoleValidation } from './types/wizardChangeRoleTypes';
import {
    initWizardChangeRoleState,
    WIZARD_CHANGE_ROLE_SET_PARAMS,
    WIZARD_CHANGE_ROLE_SET_STEP_VALID,
} from './wizardChangeRoleConstant';

export interface IWizardChangeRoleOrderSubscriber {
    subsId: number;
    msisdn: string;
}

export interface IWizardChangeRoleSubsAccessLevel {
    id: number;
    def: string;
}

export interface IWizardChangeRoleOrderResult {
    orderSubs: IWizardChangeRoleOrderSubscriber[];
}

export interface IWizardChangeRoleReducer {
    selectedAccessLevel: IWizardChangeRoleSubsAccessLevel;
    subsAccessLevels: IWizardChangeRoleSubsAccessLevel[];
    orderResult: IWizardChangeRoleOrderResult;
    subscriberIds: number[];
    removedSubscribers: number[];
    validation: IWizardChangeRoleValidation;
}

const wizardChangeRoleReducer: Reducer<IWizardChangeRoleReducer, TWizardChangeRoleActions> = (
    state = initWizardChangeRoleState,
    action: TWizardChangeRoleActions,
) =>
    produce(state, (draft) => {
        switch (action.type) {
            case WIZARD_CHANGE_ROLE_SET_PARAMS:
                Object.assign(draft, { ...draft, ...action.payload });
                break;
            case WIZARD_CHANGE_ROLE_SET_STEP_VALID:
                draft.validation.isValid = action.payload.isStepValid;
                draft.validation.error = action.payload.validateError;
                break;

            case WIZARD_STORAGE_CLEAR_STEPS:
                Object.assign(draft, initWizardChangeRoleState);
                break;
        }
    });

export default wizardChangeRoleReducer;
